import { App } from './App';

// ipvalidationAuto how to use:
// add the class "ipvalidateenabled" to your html input tag
// add attributes like required, min="", max=22
// add attribute ipvalidate="[json]" for more options
// call App.ipvalidationAuto.Init
// Done
App.ipvalidationAuto = new function () {
    var self = this;

    this.Setting = {};
    this.init = function (ipvalidationAutoSettings) {
        $('.ipvalidateenabled').on('blur', function (evnt) {
            if (self.IPValidate(this)) {
                self.IPValidateFormat(this);
            }
        }).on('focus', function (evnt) {
            setValidationOk(this);
        }).on('input', function (evnt) {
            self.IPValidateKeypress(evnt, this);
        });
    };

    this.isHidden = elm => (elm.offsetParent === null);

    this.IPValidateElements = function (selectorString) {
        let ok = true;
        $(selectorString).each(function (index) {
            var me = $(this);
            if (!self.IPValidate(this, true)) {
                ok = false;
            }
        });

        return ok;
    };


    this.IPValidateElementsScrollToErr = function (selectorString) {
        let ok = true;
        let frst = null;
        $(selectorString).each(function (index) {
            if (!self.IPValidate(this, true)) {
                if (ok) frst = this;
                ok = false;
            }
        });

        if (!ok) {
            self.scrollToElm(frst);
        }

        return ok;
    };

    this.scrollToElm = function(elm) {
        $('html, body').animate({ scrollTop: $(elm).offset().top - 20 }, 800);
    };

    this.IPValidateEnter = (evnt, ths) => setValidationOk(ths);

    this.IPValidateKeypress = function (evnt, ths) {
        var ipValidateObj = getIPValidateObj(ths);
        var prvnt = false;

        if (ipValidateObj.type == 'integer') prvnt = (evnt.which < 48 || evnt.which > 57);
        if (this.type == 'number' || ipValidateObj.type == 'number') prvnt = ((evnt.which < 48 || evnt.which > 57) && evnt.key != ',' && evnt.key != '.');
        if (prvnt) evnt.preventDefault();
    };

    this.IPValidateFormat = function (element) {
        var ipValidateObj = getIPValidateObj(element);
        if (ipValidateObj.type == 'integer') {
            var v = getInputNumber(element).toLocaleString('da');
            element.value = v;
        }
    };

    this.IPValidate = function (element, doNotUseDefault) {
        var jelem = $(element);
        var value = element.value;
        var ipValidateObj = getIPValidateObj(element);
        if (!value) {
            if (ipValidateObj.whenBlankDefaultTo && !doNotUseDefault) {
                value = element.value = ipValidateObj.whenBlankDefaultTo;
            } else {
                return ipValidateObj.required ? setValidationError(element, '', true) : setValidationOk(element);
            }
        }

        if (ipValidateObj.type) {
            if (ipValidateObj.type === 'isbn') return validateIBAN(element);
            if (ipValidateObj.type === 'swift') return validateSwift(element);
            if (ipValidateObj.type === 'kontonr') return validateKontoNr(element);
            if (ipValidateObj.type === 'onlyletters') return validateOnlyLetters(element);
            if (ipValidateObj.type === 'onlylettersdk') return validateOnlyDkLetters(element);
            if (ipValidateObj.type === 'onlylettersdkwhitespaceallowed') return validateOnlyDkLettersOneWhiteSpaceAllowed(element);
            if (ipValidateObj.type === 'cpr11') return modulus11Cpr(element);
            if (ipValidateObj.type === 'cpr') return validateCpr(element);
            if (ipValidateObj.type === 'cprPensionsplan2022') return validateCprPensionsplan2022(element);
            if (ipValidateObj.type === 'cvr') return validateCvr(element);
        }

        if (element.type === 'email' || ipValidateObj.type === 'email') {
            return ipValidateObj.required ? validateEmailRequired(element) : validateEmail(element);
        }
        if (element.type === 'phone' || ipValidateObj.type === 'phone') {
            return ipValidateObj.required ? validateTelefonRequired(element) : validateTelefon(element);
        }

        if (element.type === 'date' || ipValidateObj.type === 'date') {
            return ipValidateObj.required ? validateDateRequired(element, ipValidateObj.min, ipValidateObj.max) : validateDate(element, ipValidateObj.min, ipValidateObj.max);
        }

        if (element.type === 'number' || ipValidateObj.type === 'integer' || ipValidateObj.type === 'number' || ipValidateObj.fixedFraction) {
            var num = getInputNumber(element);
            if (isNaN(num)) {
                return setValidationError(element);
            }

            if (!isNaN(ipValidateObj.min) && num < ipValidateObj.min) {
                if (ipValidateObj.onOutOfRange == 'useMinMax') {
                    element.value = ipValidateObj.min;
                } else {
                    return setValidationError(element);
                }
            }
            if (!isNaN(ipValidateObj.max) && num > ipValidateObj.max) {
                if (ipValidateObj.onOutOfRange == 'useMinMax') {
                    element.value = ipValidateObj.max;
                } else {
                    return setValidationError(element);
                }
            }
        }
        if (element.type === 'radio' || ipValidateObj.type === 'radio') {
            const name = element.name;
            const radioElms = [...document.querySelectorAll(`[name=${name}]`)];
            const hasCheckedVal = radioElms.some(radioElm => radioElm.checked);
            if (!hasCheckedVal) {
                return setValidationError(element);
            }
        }
        // fixedFraction should be a number indicating the amount of decimals.
        // Set this to 0 to not allow decimals at all.
        if (ipValidateObj.fixedFraction !== undefined) {
            var v = getInputNumber(element);
            element.value = v.toFixed(ipValidateObj.fixedFraction).replace(',', '').replace('.', ',');
            if (element.value == '') element.value = v.toFixed(ipValidateObj.fixedFraction);
        }

        setValidationOk(element);
        return true;
    };

    function getInputNumber(elm) {
        var u = elm.value.replace(/\./g, '').replace(/,/g, '.');
        var v = (elm.valueAsNumber && !isNaN(elm.valueAsNumber)) ? elm.valueAsNumber : Number(u);
        var b = (elm.valueAsNumber) ? true : false;
        return v;
    }

    // replacing PlaceHolders in tmplString wiht matchng values form keyvalues
    function PhReplace(tmplStr, keyvalues) {
        if (!tmplStr) return tmplStr;
        return tmplStr.replace(/(\{(\w+)\})/g, function (k1, k2, k3) { return (keyvalues[k3] != null) ? keyvalues[k3] : k1; });
    }

    // Getting the data-ipvalidate from the element - supposed to be in json format!
    function getIPValidateObj(element) {
        var jelem = $(element);
        var ipvalidateText = jelem.data('ipvalidate');
        var ipValidateObj = ipvalidateText || {};

        if (typeof (ipValidateObj) == 'string' && ipvalidateText) ipValidateObj = JSON.parse(ipvalidateText);
        if (jelem[0].hasAttribute('max')) ipValidateObj.min = parseInt(jelem.attr('min'), 10);
        if (jelem[0].hasAttribute('max')) ipValidateObj.max = parseInt(jelem.attr('max'), 10);
        ipValidateObj.required = ipValidateObj.required || (jelem && jelem.attr('required'));

        return ipValidateObj;
    }

    // !!! overriding setValidationError in IP.Validation.js (adding setValidationErrorPre(..))
    function setValidationError(element, txt, useRequiredtext) {
        if (!(element instanceof jQuery)) element = $(element);

        setValidationErrorPre(element, txt, useRequiredtext);
        element.closest('div.fu').find('div.error').show();
        element.closest('div.fu').addClass('error');
    }

    // Will manage texts for the error message
    function setValidationErrorPre(elem, txt, useRequiredtext) {
        if (!(elem instanceof jQuery)) {
            elem = $(elem);
        }

        const fuElm = elem.closest('div.fu');
        const msgElms = fuElm
            .find('div.msg')
            .filter((idx, msgElm) => $(msgElm).closest('div.fu').get(0).isSameNode(fuElm.get(0)));

        const msgdiv = msgElms.first();
        var defaultText = msgdiv.data('defaulttext');
        var txtInner = msgdiv.text();
        if (!defaultText && txtInner) {
            msgdiv.data('defaulttext', txtInner);
            defaultText = txtInner;
        }
        var tmpl = useRequiredtext ? elem.data('requirederrtmpl') : elem.data('formaterrtmpl');
        if (txt) {
            const textField = msgdiv.children().length ? msgdiv.children().get(0) : msgdiv;
            textField.text = txt;
        } else if (tmpl) {
            var ipValidateObj = getIPValidateObj(elem[0]);
            var t = function () {
                return PhReplace(tmpl, ipValidateObj);
            };
            msgdiv.text(t);
        } else if (defaultText) {
            const textField = msgdiv.children().length ? msgdiv.children().get(0) : msgdiv;
            textField.text = defaultText;
        }
    }
};
